import React, { Fragment } from 'react';
import ReactMarkdown from 'react-markdown';
import PropTypes from 'prop-types';
import Checkbox from '../../../../components/checkbox/Checkbox';
import SimpleRow from '../../../../components/simpleRow/SimpleRow';
import ComponentWithPopover from '../../../../components/componentWithPopopver/ComponentWithPopover';
import './Observation.scss';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const Observation = ({
    id,
    name,
    measure,
    measureTitle,
    description,
    withDescription,
    handleCheckboxChanged,
    isSelected,
    groupName,
    studentId,
    onHelpIconClick,
    lrsGroup,
}) => {
    const popoverRef = React.createRef();

    const handleOnBlur = () => {
        if (popoverRef.current) popoverRef.current.hide();
    };

    const handleCheckboxClick = isChecked => {
        handleCheckboxChanged(isChecked, id, name, measureTitle, measure);
    };

    const handleHelpClick = () => {
        onHelpIconClick(name, measureTitle, measure, studentId, lrsGroup);
    };

    return (
        <SimpleRow
            rowClassNames={`observation-row ${isSelected && 'selected'}`}
            cellClassNames="observation-cell"
            columns={[
                <Fragment key="observation-name">
                    <Checkbox
                        id={generateReactKey(id, groupName)}
                        handleCheckboxChanged={handleCheckboxClick}
                        isChecked={isSelected}
                    />
                    <div className="observation-name" tabIndex={-1} onBlur={handleOnBlur}>
                        {name}
                        {withDescription && (
                            <ComponentWithPopover
                                title="What does this mean?"
                                message={<ReactMarkdown>{description}</ReactMarkdown>}
                                className="nav-popover"
                                ref={popoverRef}
                            >
                                {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
                                <i
                                    className="icon-amplify-info-outline pointer"
                                    onClick={handleHelpClick}
                                />
                            </ComponentWithPopover>
                        )}
                    </div>
                </Fragment>,
                <div key="skill-section" className="skill-section">
                    <span className="measure-title">{measureTitle}</span>
                    <span className="measure-name">{measure}</span>
                </div>,
            ]}
        />
    );
};

Observation.defaultProps = {
    id: '',
    name: '',
    measure: '',
    measureTitle: '',
    description: '',
    studentId: '',
    withDescription: false,
    handleCheckboxChanged: () => {},
    onHelpIconClick: () => {},
    isSelected: false,
    groupName: null,
    lrsGroup: '',
};

Observation.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    measure: PropTypes.string,
    measureTitle: PropTypes.string,
    description: PropTypes.string,
    studentId: PropTypes.string,
    withDescription: PropTypes.bool,
    handleCheckboxChanged: PropTypes.func,
    onHelpIconClick: PropTypes.func,
    isSelected: PropTypes.bool,
    groupName: PropTypes.string,
    lrsGroup: PropTypes.string,
};

export default Observation;
